import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./components/language/LanguageProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import HomePage from "./components/HomePage";
import BusinessCardCreator from "./components/BusinessCardCreator";
import CustomerAuth from "./components/auth/CustomerAuth";
import CustomerDashboard from "./components/customer/CustomerDashboard";
import EnhancedResellerDashboard from "./components/reseller/EnhancedResellerDashboard";
import ResellerUpgrade from "./components/reseller/ResellerUpgrade";
import AdminLogin from "./components/admin/AdminLogin";
import EnhancedAdminDashboard from "./components/admin/EnhancedAdminDashboard";
import CardPreview from "./components/CardPreview";
import AIChat from "./components/chat/AIChat";
import CustomerProfilePanel from "./components/customer/CustomerProfilePanel";
import SmartCardPublic from "./components/smartcard/SmartCardPublic";
import ShowcaseGallery from "./components/showcase/ShowcaseGallery";
import CanvasEditorPage from "./components/canvas/CanvasEditorPage";

function App() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <LanguageProvider>
      <ErrorBoundary>
      <div className="App min-h-screen bg-gray-50">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<CustomerAuth />} />
            <Route path="/signup" element={<CustomerAuth />} />
            <Route path="/dashboard" element={<CustomerDashboard />} />
            <Route path="/profile" element={<CustomerProfilePanel />} />
            <Route path="/sc/:slug" element={<SmartCardPublic />} />
            <Route path="/showcase" element={<ShowcaseGallery />} />
            <Route path="/canvas/:cardId" element={<CanvasEditorPage />} />
            <Route path="/reseller-dashboard" element={<EnhancedResellerDashboard />} />
            <Route path="/reseller-upgrade" element={<ResellerUpgrade />} />
            <Route path="/create" element={<BusinessCardCreator />} />
            <Route path="/preview/:id" element={<CardPreview />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<EnhancedAdminDashboard />} />
            <Route path="/admin/*" element={<EnhancedAdminDashboard />} />
          </Routes>
          <Toaster />
          
          {/* Global AI Chat Widget */}
          <AIChat 
            isOpen={chatOpen} 
            onToggle={() => setChatOpen(!chatOpen)}
            userType="customer"
          />
        </BrowserRouter>
      </div>
      </ErrorBoundary>
    </LanguageProvider>
  );
}

export default App;